import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { Table, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { withTranslation } from 'react-i18next';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[400],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

class ValidationDialog extends Component {



    render() {
        let { responseData } = this.props;

        return (
            <Dialog onClose={() => this.props.onClose()} open={this.props.isOpen} TransitionComponent={Transition} maxWidth={"lg"}>
                <DialogTitle className="dialog-header-custom" onClose={this.props.onClose}>{this.props.title} </DialogTitle>
                <DialogContent>
                    <p><span><b>{this.props.t("file_name")}: </b></span><span>{responseData && responseData.fileName}</span></p>
                    <p><span><b>{this.props.t("file_extension")}: </b></span> <span>{responseData && responseData.fileExtension}</span></p>
                    <p><span><b>{this.props.t("worksheet_name")}: </b></span><span>{responseData && responseData.worksheetName}</span></p>
                    <p><span><b>{this.props.t("number_of_rows")}: </b></span><span>{responseData && responseData.numberOfRows}</span></p>
                    <p><span><b>{this.props.t("number_of_empty_rows")}: </b></span><span>{responseData && responseData.numberOfEmptyRows}</span></p>
                    <p><span><b>{this.props.t("number_of_invalid_rows")}: </b></span><span>{responseData.invalidRows && Object.keys(responseData.invalidRows).length}</span></p>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>{this.props.t("invalid_rows")}</strong></TableCell>
                                <TableCell><strong>{this.props.t("type")}</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        {Object.keys(responseData).length > 0 && Object.entries(responseData.invalidRows).map((field, index) => {
                            return <TableBody key={index}>
                                <TableRow key={index}>
                                    <TableCell>
                                        {field[0]}
                                    </TableCell>
                                    <TableCell>
                                        <>
                                            {Object.entries(field[1]).map((field1, index) => {
                                                return <p key={index} style={{ color: 'red', fontSize: '12px', fontWeight: 'bold' }}>{this.props.t(field1[1])}</p>
                                            })}
                                        </>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        })}
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button color="inherit" variant="contained" onClick={() => this.props.onClose()}>
                        {this.props.closeButtonTitle}
                    </Button>
                    <Button type="submit" variant="contained" color="secondary" onClick={() => this.props.onConfirm()}>
                        {this.props.confirmButtonTitle}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation()(ValidationDialog);
